export enum AlertPreferencesType {
  COLLECTION_PREPARED = "COLLECTION_PREPARED",
  EXPECTED_CLEAN_UP = "EXPECTED_CLEAN_UP",
  LOW_ACCOUNT = "LOW_ACCOUNT",
  NOT_DOWNLOADED_DOCUMENT = "NOT_DOWNLOADED_DOCUMENT",
  TRANSACTION_SENT = "TRANSACTION_SENT",
  SIGNATURE_PERFORMED = "SIGNATURE_PERFORMED",
  COLLECTION_PAUSED = "COLLECTION_PAUSED",
  EXPECTED_EXPIRATION = "EXPECTED_EXPIRATION",
  COLLECTION_EXPIRED = "COLLECTION_EXPIRED",
  COLLECTION_RELAUNCHED = "COLLECTION_RELAUNCHED",
  SIGNATURES_COLLECTION_DONE = "SIGNATURES_COLLECTION_DONE",
  SIGNATURE_REFUSED = "SIGNATURE_REFUSED",
  SEALING_COLLECTION_DONE = "SEALING_COLLECTION_DONE",
  SEALING_ERROR = "SEALING_ERROR",
  ACCOUNT_CREDITED = "ACCOUNT_CREDITED",
  CONFIDENTIALITY_PROPERTY_REMOVED = "CONFIDENTIALITY_PROPERTY_REMOVED",
  BILL_SENT = "BILL_SENT",
  MERGED = "MERGED",
  MIGRATION = "MIGRATION",
  DEGRADED_MODE = "DEGRADED_MODE",
  UNKNOWN = "UNKNOWN",
}
